import type { AnyPatternContext } from "./context";
import type { AnyPattern } from "./pattern";

export const elementToPattern = new WeakMap<AnyPattern, AnyPatternContext | undefined>();
